var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vlider',{attrs:{"id":'first',"vlider-data":_vm.slider,"theme":'theme-dark'},on:{"click":_vm.vliderClick},model:{value:(_vm.inputRange),callback:function ($$v) {_vm.inputRange=$$v},expression:"inputRange"}})
}
var staticRenderFns = []

export { render, staticRenderFns }